import { action } from 'easy-peasy';
import { IActionSetTriageRequest } from '../types';

const setTriageRequest: IActionSetTriageRequest = action((state, payload) => {
  state.request = payload;
});

export default setTriageRequest;
